//import DataIo from "@/pcomponents/common/content/chat/data_io";
/*
import CommonDataIo from "@/pcomponents/common/content/chat/data_io";
function DataIo(props: any) {
  let myProps = {
    data_io_ref: null,
    infoArr: [],
    setInfoArr: (inData: any) => { },
    ...props
  };

  const on_receive=(msg:any)=>{
    console.log("DataIo on_receive", msg);
  };

  return (
    <>
      <CommonDataIo
        ref={myProps.data_io_ref}
        on_receive={on_receive}
      ></CommonDataIo>
    </>
  );
};
export default DataIo;
*/
import get_chat_socket from "@/pcomponents/common/content/chat/socket";
import { useSelector } from 'react-redux';
import { useState, useEffect, forwardRef, useImperativeHandle } from 'react';

const DataIo = forwardRef((props: any, ref) => {
  let myProps = {
    on_receive: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  let iam_mcomp_seq = user.comp_seq;
  let iam_mcomp_user_seq = user.user_seq;
  const [socket, setSocket] = useState<any>(null);
  useEffect(() => {
    let chat_socket: any = null;
    if (iam_mcomp_seq) {
      chat_socket = get_chat_socket();
      setSocket(chat_socket);
      chat_socket.emit("set_user_data", {
        "comp_room_id": iam_mcomp_seq + ",data_check",
        "comp_seq": iam_mcomp_seq,
        "user_name": user.user_name,
        "user_seq": iam_mcomp_user_seq,
      });
      chat_socket.on("update_data_msg", (msg: any) => {
        myProps.on_receive(msg);
      });
    }
    return () => {
      if (chat_socket) {
        chat_socket.disconnect();
      }
    };
  }, [user]);

  const send = function (in_msg: any) {
    if (socket) {
      let send_msg = {
        socket_id: socket.id,
        sort: "daily_report",
        detail: "user_arr",
        iam_mcomp_seq: iam_mcomp_seq,
        iam_mcomp_user_seq: iam_mcomp_user_seq,
        data: "",
        ...in_msg
      };
      socket.emit("update_data_msg", send_msg);
    }
  };

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    send
  }));

  return (
    <></>
  );
});
export default DataIo;